module.exports = __webpack_public_path__ + "assets/img/v_model_detail.4e905625.jpg";